<template>
<apexchart type="line" height="200" :options="chartOptions" :series="series"></apexchart>
</template>
<script>

import VueApexCharts from "vue-apexcharts"
export default {
  name: 'energy-vs-production',
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    block: Object,
    default: {},
    range: Object
  },
  mounted() {
    this.fetchCounts()
  },
  watch: {
    block() {
      this.fetchCounts()
    },
    range() {
      console.log('change range', this.range)
      this.fetchCounts()
    }
  },
  methods: {
    async fetchCounts() {
      console.log('Energy fetchCounts', this.block)
      let payload = {
        devid: this.block.devid,
        blockid: this.block.blockid,
        type: this.block.type,
        start: Math.round(this.range.start.getTime() / 1000),
        end: Math.round(this.range.end.getTime() / 1000)
      }
      const presponse = await this.$http.get(`/energy?funcname=production&devid=${payload.devid}&start=${payload.start}&end=${payload.end}`)
      let productiondata = presponse.data.map((val) => {
        return {
          x: new Date(val.timestamp + 'Z').getTime(),
          y: val.value
        }
      });
      const eresponse = await this.$http.get(`/energy?funcname=byminute&meterid=${payload.blockid}&metertype=${payload.type}&start=${payload.start}&end=${payload.end}`)
      let energydata = eresponse.data.map((val) => {
        return {
          x: new Date(val.timestamp + 'Z').getTime(),
          y: val.value
        }
      });
      this.series = [{name: 'Producción', data: productiondata}, {name: 'Energía', data: energydata}]
    },
  },
  data() {
    return {
      series: [{data: []}],
      chartOptions: {
        chart: {
          height: 200,
          type: 'line',
          stacked: false,
          zoom: {
            enabled: false
          },
          toolbar: {
            show: false
          }
        },
        colors: ["#253A92", "#E48700"],
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'straight',
          width: 2
        },
        fill: {
          opacity: 1
        },
        markers: {
          size: 0
        },
        xaxis: {
          type: "datetime",
          labels: {
            datetimeUTC: false
          },
          tooltip: {
            enabled: false
          }
        },
        yaxis:[
          {
            seriesName: 'Producción',
            opposite: false,
            axisTicks: {
              show: true,
            },
            axisBorder: {
              show: true,
              color: '#253A92'
            },
            labels: {
              style: {
                colors: '#253A92',
              }
            },
            title: {
              text: "Producción",
              style: {
                color: '#253A92',
              }
            },
          },
          {
            seriesName: 'Energía',
            opposite: true,
            axisTicks: {
              show: true,
            },
            axisBorder: {
              show: true,
              color: '#E48700'
            },
            labels: {
              style: {
                colors: '#E48700',
              }
            },
            title: {
              text: "Energía",
              style: {
                color: '#E48700',
              }
            },
          }
        ]
      }
    }
  }
}
</script>
